import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '@core/api/base/api-base.service';
import { AUTH_ENDPOINTS } from '@core/api/endpoints/auth.endpoints';
import { ApiResponse } from '@app/features/credits/types/credits.interface';
import { UserInfo } from '@app/core/types/user.interface';
import { createLoaderContext } from '@app/shared/utils/http-context.utils';
import { LoginPayload, LoginResponse, ResetPasswordPayload, TwoFactorSetupResponse } from '../types';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends ApiBaseService {

  login(payload: LoginPayload): Observable<unknown> {
    const context = createLoaderContext('Iniciando Sesión...');
    return this.post<unknown>(AUTH_ENDPOINTS.LOGIN, payload, { context });
  }

  logout(): Observable<ApiResponse> {
    const context = createLoaderContext('Cerrando Sesión...');
    return this.post<ApiResponse>(AUTH_ENDPOINTS.LOGOUT, {}, { context });
  }

  getStatus(): Observable<LoginResponse> {
    return this.get<LoginResponse>(AUTH_ENDPOINTS.STATUS);
  }

  getUserInfo(): Observable<UserInfo> {
    return this.get<UserInfo>(AUTH_ENDPOINTS.USER_INFO);
  }

  updateConfiguration(activeNewVersion: boolean): Observable<ApiResponse> {
    return this.post<ApiResponse>(AUTH_ENDPOINTS.CONFIGURATION, { activeNewVersion });
  }

  sendResetPasswordEmail(email: string, isNewUrl: boolean): Observable<ApiResponse> {
    const context = createLoaderContext('Enviando correo...');
    return this.post<ApiResponse>(AUTH_ENDPOINTS.FORGOT_PASSWORD, { email, isNewUrl }, { context });
  }

  verifyResetPasswordToken(id: string, companyNumber: number): Observable<ApiResponse> {
    return this.post<ApiResponse>(AUTH_ENDPOINTS.VERIFY_PASSWORD_RESET, { id, companyNumber });
  }

  verifyTwoFactorCode(payload: TwoFactorSetupResponse): Observable<ApiResponse> {
    const context = createLoaderContext('Verificando Código...');
    return this.post<ApiResponse>(AUTH_ENDPOINTS.TWO_FACTOR_VERIFY, payload, { context });
  }

  resetPassword(payload: ResetPasswordPayload): Observable<ApiResponse> {
    const context = createLoaderContext('Restableciendo contraseña...');
    return this.post<ApiResponse>(AUTH_ENDPOINTS.RESET_PASSWORD, payload, { context });
  }
}
